import React from "react";
import { css, cx } from "@linaria/core";
import { spacings } from "../Theme";

interface WithKey {
  id: string;
  label: string;
}
interface FiltersListProps<T extends WithKey> {
  filters: T[];
  renderFilter: (f: T) => React.ReactNode;
  className?: string;
}

const FilterList = <T extends WithKey>({
  filters,
  renderFilter,
  className,
}: FiltersListProps<T>) => {
  const sortFilters = React.useMemo(
    () => filters.sort((a, b) => a.label.localeCompare(b.label)),
    [filters],
  );

  if (sortFilters.length === 0) return null;

  return (
    <div className={cx(className, filterList)}>
      {sortFilters.map(f => (
        <React.Fragment key={f.id}>{renderFilter(f)}</React.Fragment>
      ))}
    </div>
  );
};

export default FilterList;

//#region CSS
const filterList = css`
  display: flex;
  gap: ${spacings.xs};
  flex-wrap: wrap;
`;
//#endregion CSS
